import { useRef } from 'react';

import { css } from '@betterment/samba-styled-system/css';

import { GraphQLProvider } from '../../RetailApp/graphql';
import { IdempotencyProviderWithFeatureRegistry } from '../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { urlBuilder } from '../../Shared/urlBuilder';
import useCapitalizeWindowEvents from '../hooks/useCapitalizeWindowEvents';
import useSerializedWindowEventMutationHandler from '../hooks/useSerializedWindowEventMutationHandler';

interface Props {
  webviewUrl: string;
}

const CapitalizeTransactionDetailsWebview: React.FC<Props> = ({ webviewUrl }) => {
  const ref = useRef<HTMLIFrameElement>(null);

  const processWindowEvent = useSerializedWindowEventMutationHandler();

  useCapitalizeWindowEvents({
    onCapitalizeExit: () => {
      ref.current?.dispatchEvent(new CustomEvent('modal:close', { bubbles: true }));
    },
    onCreateRothDestinationNeeded: () => {
      window.location.href = urlBuilder.appAddGoalFlowsNew.absolute({ product_category: 'retirement' });
    },
    onCreateTradDestinationNeeded: () => {
      window.location.href = urlBuilder.appAddGoalFlowsNew.absolute({ product_category: 'retirement' });
    },
    onCapitalizeRolloverCanceled: processWindowEvent,
  });

  return (
    <iframe
      ref={ref}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className={css({
        position: 'absolute',
        width: '100%',
        height: '100%',
        border: 'none',
      })}
      src={webviewUrl}
      title="Capitalize transaction details"
    />
  );
};

const WithProviders: React.FC<Props> = props => {
  return (
    <GraphQLProvider>
      <IdempotencyProviderWithFeatureRegistry featureName="capitalizeRollovers">
        <CapitalizeTransactionDetailsWebview {...props} />
      </IdempotencyProviderWithFeatureRegistry>
    </GraphQLProvider>
  );
};

export default WithProviders;
